import { memo, useMemo } from 'react'
import classNames from 'classnames'

import {
  TableDataViewCell,
  TableDataViewCellProgress
} from '@aytm/app/stats/page/question-views/components/table/types'

// styles
import style from '@aytm/app/stats/page/question-views/components/table/styles/Table.module.scss'

type TableCellProgressProps = { cell: TableDataViewCell; width: number | string }

type StylesProps = {
  flexGrow?: number
  flexShrink?: number
  flexBasis?: string
  width?: string
}

export default memo(TableCellProgress)
export function TableCellProgress(props: TableCellProgressProps) {
  const cell = props.cell as TableDataViewCellProgress

  const styles = useMemo(() => {
    const values: StylesProps = {}
    if ('width' in props && Number.isFinite(props.width)) {
      values.flexGrow = 0
      values.flexShrink = 0
      values.flexBasis = `${props.width}px`
      values.width = `${props.width}px`
    }
    if ('width' in props && 'string' == typeof props.width) {
      values.flexGrow = 0
      values.flexShrink = 0
      values.flexBasis = props.width
      values.width = props.width
    }
    return values
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.width])

  return (
    <div className={classNames(style['row-cell'], style['row-cell-progress'])} style={styles}>
      {'loading' in cell && cell.loading ? null : (
        <>
          <span
            className={style['row-cell-progress-text']}
            style={{ marginLeft: `${Math.max(1, Math.min(51, cell.percents))}%` }}
          >
            {cell.percents.toFixed(1)}%{'amount' in cell ? <> ({cell.amount})</> : null}
          </span>
          <span className={style['row-cell-progress-fill']} style={{ width: `${cell.percents}%` }} />
        </>
      )}
    </div>
  )
}
